<template>
  <b-modal :visible="visible" @change="$emit('close')" hide-footer hide-header centered size="lg" body-class="announcement-detail-body">
    <div v-if="announcement" class="announcement-detail">
      <div class="detail-top">
        <div class="type-badge" :class="isCourseScope ? 'scope-course' : 'scope-global'">
          <span class="badge-label">{{ scopeLabel }}</span>
        </div>
        <button type="button" class="detail-close" aria-label="Close" @click="$emit('close')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <h3 class="detail-title">{{ announcement.title }}</h3>
      <div class="detail-meta">
        <span>{{ formattedDate }}</span>
      </div>
      <p class="detail-message">{{ announcement.message }}</p>
    </div>
  </b-modal>
</template>

<script>
import { AnnouncementScope } from '../../constants/announcement';

export default {
  name: 'AnnouncementDetailModal',
  props: {
    announcement: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCourseScope() {
      return !!this.announcement && String(this.announcement.entityType || '').toLowerCase() === AnnouncementScope.ProductVariant.toLowerCase();
    },
    scopeLabel() {
      return this.isCourseScope ? 'Course' : 'Global';
    },
    formattedDate() {
      return this.announcement ? this.formatDate(this.announcement.date) : '';
    },
  },
  methods: {
    formatDate(dateString) {
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      return new Date(dateString).toLocaleString('en-US', options);
    },
  },
};
</script>

<style scoped>
.announcement-detail {
  padding: 4px 4px 8px;
}

.detail-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.type-badge.scope-global {
  background-color: #eef2ff;
  color: #4338ca;
  border-color: #c7d2fe;
}

.type-badge.scope-course {
  background-color: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.detail-close {
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 1.1rem;
  cursor: pointer;
  line-height: 1;
}

.detail-title {
  margin: 0 0 8px 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #111827;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.78rem;
  color: #888;
  margin-bottom: 16px;
}

.detail-message {
  margin: 0;
  max-height: 55vh;
  overflow-y: auto;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #374151;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
